import { Component, h, Prop } from '@stencil/core';
import { FontType } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-review-title',
  shadow: false,
})
export class UgcReviewTitle {
  @Prop() shareUrl?: string = '';
  @Prop() reviewTitle: string = '';
  @Prop() fontType: FontType = FontType.large;

  render() {
    const fontType = this.fontType === FontType.large ? 'fs-16' : 'fs-14';
    return this.shareUrl ? (
      <a
        href={this.shareUrl}
        class={`${fontType} bold color-gray-700 break-word pointer hover-link-gray-700`}
        data-testid="pdp-review-title"
      >
        {this.reviewTitle}
      </a>
    ) : (
      <span class={`${fontType} bold color-gray-700 break-word`} data-testid="pdp-review-title">
        {this.reviewTitle}
      </span>
    );
  }
}
